import api from './api';

const logisticsService = {
  createOrder: async (orderData) => {
    const response = await api.post('/logistics/orders', orderData);
    return response.data;
  },

  getMyOrders: async () => {
    const response = await api.get('/logistics/orders/my-orders');
    return response.data;
  },

  getOrder: async (id) => {
    const response = await api.get(`/logistics/orders/${id}`);
    return response.data;
  },

  trackOrder: async (trackingNumber) => {
    const response = await api.get(`/logistics/orders/track/${trackingNumber}`);
    return response.data;
  },

  cancelOrder: async (id, notes) => {
    const response = await api.put(`/logistics/orders/${id}/cancel`, { notes });
    return response.data;
  },
};

export default logisticsService;
